export default function KPICard({ label, value, sub, accent, testid, icon: Icon }) {
  const accentClass = {
    success: "text-[#16A34A]",
    warning: "text-[#F59E0B]",
    error: "text-[#DC2626]",
    info: "text-[#0020C2]",
  }[accent] || "text-[#0A0A0A]";

  return (
    <div className="kpi-card bg-white border border-[#E5E5E5] p-5 rounded-md" data-testid={testid}>
      <div className="flex items-start justify-between mb-4">
        <div className="text-[11px] uppercase tracking-[0.15em] text-neutral-500 font-semibold">{label}</div>
        {Icon && <Icon className="w-4 h-4 text-neutral-400" strokeWidth={1.5} />}
      </div>
      <div className={`num text-2xl md:text-3xl font-bold ${accentClass}`}>{value}</div>
      {sub && <div className="text-xs text-neutral-500 mt-1.5">{sub}</div>}
    </div>
  );
}
